import { render, staticRenderFns } from "./otaPanel.vue?vue&type=template&id=4dc91b07&scoped=true"
import script from "./otaPanel.vue?vue&type=script&lang=js"
export * from "./otaPanel.vue?vue&type=script&lang=js"
import style0 from "./otaPanel.vue?vue&type=style&index=0&id=4dc91b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc91b07",
  null
  
)

export default component.exports